import { COUPON_QUERY_PARAM } from 'src/common/constants/queryParams';
import { getQueryObjectFromLocation } from 'src/common/utils/queryString/parse';

export default function getCouponCodeFromQuery(location) {
  const query = getQueryObjectFromLocation(location);
  return query?.[COUPON_QUERY_PARAM];
}
